export const updatedRow = state => state.loggedInuser.updatedRow;
export const search = state => state.loggedInuser.search || "";
export const counter = state => state.loggedInuser.counter
export const user_uuid = state => state.loggedInuser.user_uuid
export const pseudo_uid = state => state.loggedInuser.pseudo_uid
export const month = state => state.loggedInuser.selectedMonth
export const jwt = state => {
    return state.loggedInuser.jwt
}